module.exports = __webpack_public_path__ + "static/media/16.163cf1a7.jpeg";